import * as Yup from "yup"
import i18next from "i18next"

export const TicketFormSchema = Yup.object().shape({
    premise_id: Yup.string().required(i18next.t("ticket.error_premise")),
    complaint_category: Yup.string().required(i18next.t("ticket.error_category")),
    complaint_type: Yup.string().required(i18next.t("ticket.error_complaint_type")),
    priority: Yup.string().required(i18next.t("ticket.error_priority")),
    subject: Yup.string().trim().required(i18next.t("ticket.error_subject")),
    description: Yup.string().required(i18next.t("ticket.error_description")),
    incident_date: Yup.string().required(i18next.t("ticket.error_incident_date")),
    status: Yup.string().nullable(),
})

export const AssignTicketSchema = Yup.object().shape({
    user_id: Yup.string().required(i18next.t("ticket.error_assign_user")),
})